import React, { useState, useCallback, useEffect, useRef } from 'react'
import BDT_Filter from './BDT_Filter_Bus';
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import BDT_Cards_Bus from './BDT_Cards_Bus';
import { API_URL_MAIN, INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import { decodeToken } from 'react-jwt';
import BDT_Table_Bus from './BDT_Table_Bus';
import BDT_Battery from './BDT_Battary_Bus';
import GaugeChartWithLyfCycle_Bus from './GaugeChartWithLyfCycle_Bus';
import GaugeChart_BDT from './GaugeChart_BDT';
import BDT_Dashboard_Cards from './BDT_Dashboard_Cards';
import styles from './BDT_Bus.module.css'
import useHttp from '../../../hook/use-http';
import LineChart from './LineChart';
import Test from './test';
import Test2 from './test2';
import Test3 from './test3';
import CandlestickSection from './Candlestick_Section/CandlestickSection';
import BarChartSection from './BarChart_Section/BarChartSection';
import BarChartFaultSection from './BarChart_Section/BarChartFaultSection';
import { FaAnglesRight } from "react-icons/fa6";

function BDT_HomePage_Bus() {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const city_name = decodedToken.city_name;
    const city_name_arr = city_name.split(",");
    const depo_name = decodedToken.depo_name;
    const depo_name_arr = depo_name.split(",");
    let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
    const [gloablfilter, setGloablfilter] = useState({ ...sampleObj })
    const [showSPM, setShowSPM] = useState(false)
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const header1Ref = useRef(null);
    const [header1Height, setHeader1Height] = useState(0);


    const [packType, setPackType] = useState("A")
    const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);

    useEffect(() => {
        if (!header1Ref.current) return;

        const updateHeight = () => {
            setHeader1Height(header1Ref.current.offsetHeight);
        };

        updateHeight();

        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header1Ref.current);

        return () => resizeObserver.disconnect();
    }, [])

    useEffect(() => {
        fetchData({
            url: API_URL_MAIN + "auth/logging", body: {
                page_name: "BDT"
            }
        })
    }, [])

    const filterSubmited = useCallback((data) => {
        if (data.VIN_NUM.length === 1) {
            setFromTableToFilter_vin(data.VIN_NUM[0])
        }
        setGloablfilter(data);
    }, []);


    const onreset = (data) => {
        setGloablfilter(data);
    }

    const onNavigateBack = () => {
        setShowSPM(false)
        setGloablfilter(prev => ({ ...prev, pageSelected: 1, VIN_NUM: [] }))
    }

    const tableProps = [
        { title: "Lowest SoH VINs", apiEnd: 'lowest_SOH_vins' },
        { title: "Highest Cell Temp VINs", apiEnd: 'highest_Temp_vins' },
        { title: "Lowest RUL VINs", apiEnd: 'lowest_RUL_vins' },
    ]

    const cardProps = [
        // { title: "Lowest cell RUL", apiEnd: 'lowest_cell_RUL' },
        // { title: "Lowest cell SoH", apiEnd: 'lowest_cell_SOH' },
        { title: "Lowest RUL", apiEnd: 'lowest_cell_RUL' },
        { title: "Lowest SoH", apiEnd: 'lowest_cell_SOH' },
        // { title: "Highest cell IR", apiEnd: 'highest_cell_IR' },
    ]

    const gaugeData = [
        // { range_end: 2, title: `IR (mΩ)`, step_gap: 0.5, apiEnd: 'gauge_IR', range_start: 0 },
        { range_end: 100, title: `SOH ("%")`, step_gap: 5, apiEnd: 'gauge_SOH', range_start: 80 },
    ];

    const dashboardsCards = [
        { title: "AVG Cycles Per Month", apiEnd: "avg_cycle_per_month" },
        { title: "Till Month", apiEnd: "till_month" },
        { title: "Thermal RunAway Indicator", apiEnd: "", temp: "1", tempTtl: "Time : 0 Hr 0 Min 0 Sec" },
        { title: "IR Increase Rate", apiEnd: "", temp: "2" },
        { title: "IR Increase Above Threshold", apiEnd: "", temp: "1", tempTtl: "IR Value: NA (mΩ)" },
        { title: "Temp. Increase Above Threshold", apiEnd: "", temp: "1", tempTtl: "Temperature : NA (°C)" }
    ]

    const graphData = [
        { packType: "A", apiEnd: "A_SOH_Value", },
        { packType: "B", apiEnd: "B_SOH_Value", },
        { packType: "C", apiEnd: "C_SOH_Value", },
        { packType: "D", apiEnd: "D_SOH_Value", },
    ]

    return (
        <div className={`${styles.body_bg_color}`}>
            <DashboardMain_Bus>
                <div>
                    <div ref={header1Ref} className={`${gloablfilter.pageSelected == 2 ? `${styles.pack_sticky} pt-1 bg-light` : "pt-1"}`}>
                        <BDT_Filter onsubmit={filterSubmited} gloablfilter={{ ...gloablfilter }} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} setGloablfilter={setGloablfilter} onNavigateBack={onNavigateBack} />
                    </div>
                    {
                        (gloablfilter.pageSelected == 1) ?
                            <section>
                                <div className="row text mt-3 mx-2">
                                    <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Fleet Level Monitoring​</text></div>
                                    <div className="col col-lg-3 col-sm-12 d-lg-block d-md-flex gap-md-1 mb-3">
                                        {cardProps.map((item, index) => {
                                            return (
                                                <BDT_Cards_Bus key={index} title={item.title} apiEnd={item.apiEnd} filterdata={gloablfilter} />
                                            )
                                        })}
                                        <div className={`col-lg-12 col-md-3  rounded-3 py-2 mb-2 ${styles.bg_light_blue}`}>
                                            <div className="">
                                                <p className={`h5 ${styles.bold_text} `}>Carbon Savings</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col col-12 col-lg-9">
                                        <div className={`row equal-cols`}>
                                            {tableProps.map((item, ind) => {
                                                return <BDT_Table_Bus key={ind} title={item.title} apiEnd={item.apiEnd} gloablfilter={gloablfilter} setGloablfilter={setGloablfilter} />
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </section> :
                            <>
                                <div
                                    className={`${styles.packBar} shadow-sm rounded-2 bg-white px-1 py-1`}
                                    style={{ top: `${header1Height + 2}px` }}
                                >
                                    <div className={styles.selectedPack}>
                                        <span>{`Pack ${packType}`}</span>
                                        <FaAnglesRight />
                                    </div>

                                    <div className={styles.packOptions}>
                                        {["A", "B", "C", "D"].map((pack) => (
                                            <div className={`${styles.option} ${packType === pack ? "text-white bg-secondary px-2 rounded" : ""}`} key={pack} onClick={() => setPackType(pack)}>
                                                Pack {pack}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="body-color-BDT">
                                    <div className="container-fluid body-color-BDT mt-0">
                                        {
                                            showSPM ? <>

                                                <div className='row'>
                                                    {
                                                        dashboardsCards.map((item, index) => {
                                                            return (
                                                                <div className='col col-lg-2' >
                                                                    <BDT_Dashboard_Cards key={index} data={item} filterdata={gloablfilter} packType={packType} />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <div className='shadow-sm rounded-3 bg-white p-2 ms-auto mb-4'>
                                                    <BDT_Battery filterdata={gloablfilter} packType={packType} />
                                                </div>

                                                <div className='shadow-sm rounded-3 bg-white p-2 ms-auto mb-4'>
                                                    <Test filterdata={gloablfilter} packType={packType} />

                                                </div>
                                                <div className='shadow-sm rounded-3 bg-white p-2 ms-auto mb-4'>
                                                    <Test2 filterdata={gloablfilter} packType={packType} />

                                                </div>
                                                <div className='shadow-sm rounded-3 bg-white p-2 ms-auto mb-4'>
                                                    <Test3 filterdata={gloablfilter} packType={packType} />

                                                </div>
                                            </> :
                                                <>
                                                    <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Battery Pack Health Prognostics</text></div>
                                                    <div className='row'>
                                                        {
                                                            graphData.map((data, index) => {
                                                                return (
                                                                    <div className='col col-lg-3' key={index}>
                                                                        <LineChart data={data} chartHeading={"Odometer vs A_SOH_Value"} filterdata={gloablfilter} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    <div className="container-fluid mx-auto">
                                                        <div className='row justify-content-center'>
                                                            {
                                                                gaugeData.map((item, index) =>
                                                                    <div key={index} className='col col-lg-4'>
                                                                        <div className="shadow rounded-3 bg-white my-4 d-flex justify-content-center align-content-center">
                                                                            <GaugeChart_BDT data={item} filterdata={gloablfilter} packType={packType} />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className='col col-lg-4'>
                                                                <div className="shadow rounded-3 bg-white my-4 d-flex justify-content-center align-content-center">
                                                                    <GaugeChartWithLyfCycle_Bus range_end={3000} title={"RUL (Cycles)"} step_gap={500} apiEnd="gauge_RUL" filterdata={gloablfilter} packType={packType} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='mb-4 mx-0'>
                                                            <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Temperature Candlestick Plots</text></div>
                                                            <CandlestickSection filterdata={gloablfilter} packType={packType} />
                                                        </div>
                                                        <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Duty Cycle Histograms​</text></div>
                                                        <div >
                                                            <BarChartSection filterdata={gloablfilter} packType={packType} />
                                                        </div>
                                                        <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Pack Level Faults​</text></div>
                                                        <div >
                                                            <BarChartFaultSection filterdata={gloablfilter} packType={packType} />
                                                        </div>
                                                        <div className='row'>
                                                            <div className='d-flex justify-content-center mb-2 mt-0'><text className={styles.headingBDT}>Cell Wise Statemap​​</text></div>
                                                            <div className='shadow-sm rounded-3 bg-white p-2 ms-auto mb-4'>
                                                                <BDT_Battery filterdata={gloablfilter} packType={packType} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </DashboardMain_Bus>
        </div>
    )
}

export default BDT_HomePage_Bus
